module.exports = __webpack_public_path__ + "img/save.51f14e95.svg";